import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "pulsating-dot",
    "aria-hidden": "true"
};
import { toRem } from "@/common/helpers/style";
import { computed } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'PulsatingDot',
    props: {
        color: {},
        size: {}
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "745c0a40": (sizeCSS.value),
            "c703aa7c": (colorCSS.value)
        }));
        const props = __props;
        const sizeCSS = computed(() => toRem(props.size || "0.85rem"));
        const colorCSS = computed(() => props.color || "var(--color-error)");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "pulsating-dot__ring pulsating-dot__ring--1" }, null, -1),
                _createElementVNode("span", { class: "pulsating-dot__ring pulsating-dot__ring--2" }, null, -1),
                _createElementVNode("span", { class: "pulsating-dot__ring pulsating-dot__ring--3" }, null, -1),
                _createElementVNode("span", { class: "pulsating-dot__dot" }, null, -1)
            ])));
        };
    }
});
